export default __webpack_public_path__ + "static/media/prospectus.0010dec6.pdf";